import { defineNuxtPlugin } from 'nuxt/app'

const fontSizeMap = {
  xl: '40px',
  lg: '30px',
  md: '20px',
  sm: '16px',
  xs: '14px',
  xxs: '13px',
  xxxs: '12px',
}

const colorMap = {
  // Purple
  purple100: '#f4f0fa',
  purple200: '#D9CCED',
  purple400: '#945bf1',
  purple500: '#7344c0',
  purple600: '#592f9d',
  purple800: '#2A214A',
  purpleGradient: 'linear-gradient(90deg, #3023AE 0%, #3A28B0 5%, #613BBB 23%, #6B40BE 28%, #7042BF 30%, #7B48C2 36%, #C86DD7 72%, #ed8eec 100%)',

  // Green
  green100: '#effbf3',
  green200: '#d5f3e1',
  green500: '#2dc26a',
  green600: '#25A95B',
  // Pink
  pink200: '#fbf6fc',
  pink500: '#e2b3e9',
  // Orange
  orange200: '#FFF0E2',
  orange500: '#ff8b25',
  // Red
  red100: '#FFF1F1',
  red400: '#ffccc3',
  red500: '#fc4349',
  // Blue Grey
  blueGrey400: '#edeef1',
  blueGrey500: '#DCDEE4',
  blueGrey600: '#b4b9c4',
  blueGrey700: '#8e97a6',
  blueGrey800: '#43516b',
  blueGrey900: '#1f2844',
  // Sky Blue Grey
  skyBlueGrey300: '#f6f9fc',
  skyBlueGrey400: '#edf1f5',
  skyBlueGrey500: '#d8dde3',
  skyBlueGrey600: '#c8d0d7',
  skyBlueGrey700: '#8492a6',
  skyBlueGrey800: '#546573',

  // Third Party
  facebook: '#4161a4',
  messenger: '#0490ff',
  youtube: '#e10302',
  snapchat: '#fffd00',
  spotify: '#20dc6c',
  twitter: '#74b5e4',
  email: '#7344C0',
  instagramDirectMessage: 'black',
  whatsapp: '#42ca56',
  sms: '#33c975',
  linkedin: '#0286bd',
  lightspeed: '#ed5153',
  zoom: '#2196F3',
  patreon: '#FB424D',
  stripe: '#635BFF',
  vimeo: '#11AFF5',
  eventbrite: '#F7682F',
  memberful: '#EF5028',
  eventGenius: '#1A1919',
  universe: '#3A66E5',
  eventix: '#0069ff',
  moshtix: '#00CE00',
  dice: '#000000',
  ticketek: '#04abed',
}

const zIndexMap = {
  lowest: -1,
  low: 0,
  regular: 1,
  high: 2,
  highest: 3,
  globalLowest: 80,
  globalLow: 99,
  globalRegular: 100,
  globalHigh: 999,
  globalHighest: 9999,
}

export default defineNuxtPlugin({
  name: 'ar-style',
  parallel: true,
  async setup(app: any) {
    const arStyle = {
      font: {
        size: fontSizeMap,
      },
      color: colorMap,
      zIndex: zIndexMap,
    }
    app.vueApp.config.globalProperties.$arStyle = arStyle
    app.provide('arStyle', arStyle)
  },
})
